module.exports = __webpack_public_path__ + "static/beth-e9204b7d981dca2c3a27368d7195c14a.jpg";